export const messages = {
  message: {
    login: {
      title: 'Login',
      header: 'Sign In to ZeekDoc clinical account',
      user_placeholder: 'Username',
      password_placeholder: 'Password',
      submit: 'Login',
      forgot_password: 'Forgot password?'
    },
    menu: {
      dashboard: 'Dashboard',
      appointment_pending: 'Pending',
      appointments: 'Appointments',
      patient: 'Patients',
      clinic_info: 'Clinic',
      clinic_information: 'Information',
      clinic_address: 'Address',
      clinic_schedule: 'Schedules',
      clinic_services: 'Services',
      clinic_settings: 'Settings',
      clinic_leave: 'Leave',
      sms_broadcast: 'SMS broadcast',
      doctor: 'Doctor',
      doctors: 'Doctors',
      article: 'Articles',
      feedback: 'Feedbacks',
      report: 'Report',
      clinic_view: 'Go to Clinic',
      doctor_view: 'Go to Doctor',
      my_subcription: 'My subscription',
      sign_out: 'Sign Out'
    },
    menu_message: {
      in_active_feature: 'This feature is inactive.'
    },
    clinic: {
      step_title: 'Create Profile',
      step_info: 'Information',
      step_address: 'Contact',
      step_schedule: 'Schedule',
      step_services: 'Services',
      step_doctors: 'Doctors',
      create_clinic_success: 'Profile was created successfully'
    },
    clinic_address: {
      title: 'Contact',
      address: 'Address',
      address_th: 'Address (Thai)',
      address_en: 'Address (English)',
      province: 'Province',
      district: 'District',
      insurances: 'Insurance',
      contact_info: 'Contact',
      email: 'Email',
      facebook: 'Facebook',
      website: 'Website',
      clinic_map: 'Map',
      nearby_search: 'Nearby'
    },
    pagination: {
      show: 'show',
      from: 'from',
      prev: 'Prev',
      next: 'Next',
      rows: 'rows'
    },
    doctors: {
      title: 'Doctors',
      search_doctor: 'search name',
      doctor_unit: 'doctors',
      no_doctor: 'no doctors',
      name_th: 'Name (Thai)',
      name_en: 'Name (English)',
      prefix: 'Prefix',
      firstname: 'Firstname',
      lastname: 'Lastname',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      specialty: 'Specialty',
      specialty_placeholder: 'select specialty',
      subspecialty: 'Subspecialty',
      subspecialty_placeholder: 'select subspecialty',
      prefix_required: 'The prefix field is required.',
      firstname_required: 'The firstname field is required.',
      lastname_required: 'The lastname field is required.',
      specialty_required: 'The specialty field is required.',
      filter_specialty: 'Specialty',
      filter_subspecialty: 'Subspecialty',
      qr_code: 'QR'
    },
    clinic_info: {
      title: 'Information',
      clinic_name: 'Name',
      clinic_name_th: 'Name (Thai)',
      clinic_name_en: 'Name (English)',
      clinic_logo: 'Logo',
      clinic_albums: 'Albums',
      clinic_detail: 'Detail',
      clinic_detail_th: 'Detail (Thai)',
      clinic_detail_en: 'Detail (English)',
      clinic_info: 'Information',
      clinic_info_th: 'Information (Thai)',
      clinic_info_en: 'Information (English)',
      clinic_info_placeholder_th: 'Information about clinic',
      clinic_info_placeholder_en: 'Information about clinic',
      clinic_picture_ph: 'select your photo',
      video_links: 'Related Video',
      youtube_link: 'Youtube Link'
    },
    schedules: {
      title: 'Schedules',
      schedule_for: 'Schedules of ',
      online_appointment_on: 'Online Appointment',
      select_time_slot: 'Select Time',
      to: 'to',
      add_time_slot: 'Add Time',
      hide: 'Hide',
      show: 'Show',
      options: 'Options',
      week: 'Week',
      last_week: 'Last week of a month',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      select_time_slot_number: 'Select Time Slot',
      time_slot_e_g: 'E.g. if you choose 30 minutes, system will display 8.00, 8.30, 9.00, 9.30',
      example: 'Example',
      booking_number: 'Booking number is',
      booking_unit: 'persons',
      booking_number_per_time_slot: 'Booking number per time slot',
      booking_number_per_time_slot_e_g: 'E.g. if time slot is 30 minutes and booking number per time slot is 4 persons, system will show you can serve 4 persons in 30 minutes'
    },
    services: {
      title: 'Services',
      price: 'Price',
      price_from: 'Start Price',
      price_to: 'End Price',
      price_range: 'Price Range',
      no_services: 'No service',
      add_new_service: 'Add service',
      service_name_th: 'Name (Thai)',
      service_name_en: 'Name (English)',
      select_duration: 'Select duration',
      service_duration: 'Duration',
      minutes: 'minutes',
      baht: 'บาท',
      service_detail: 'Detail',
      service_detail_th: 'Detail (Thai)',
      service_detail_en: 'Detail (English)',
      service_name_require: 'The name field is required.',
      service_duration_require: 'The duration field is required.',
      service_price_require: 'The price field is required.'
    },
    settings: {
      title: 'Settings',
      notification: 'Notification',
      notify_when_appointment: 'Notify SMS when admin created appointment',
      new_appointment_fwd_to_mail: 'Forward an appointment to email for a new appointment',
      email: 'Email',
      notify_sms: 'Notify SMS',
      notify_before_one_day: 'Notify appointment before 1 day of appointment day',
      notify_appointment_day: 'Notify appointment in appointment day',
      notify_time: 'Appointment notification time',
      credit_remain: 'Credit Remain',
      auto_create_patient: 'Auto create patient',
      feedback: 'Feedback',
      show_feedback: 'Show Feedback',
      time: 'at',
      search: 'Search',
      search_display: 'Display my profile in search algorithm'
    },
    leave: {
      title: 'Leave',
      date: 'Date',
      name: 'Name',
      remark: 'Remark',
      no_leave: 'No leave',
      title_add: 'Add Leave',
      title_edit: 'Edit Leave',
      doctor: 'Doctor',
      doctor_placeholder: 'Select Doctor',
      leave_date: 'Date',
      to: 'To',
      all_time: 'All Time',
      leave_date_placeholder: 'Select date',
      leave_time_placeholder: 'Select time',
      doctor_require: 'The doctor field is required.',
      time_require: 'The time field is required.',
      time_invalid: 'The time is invalid.',
      search_doctor: 'search name',
      calendar: 'Calendar',
      list: 'List'
    },
    article: {
      title: 'Article',
      search_article: 'Search article',
      no_article: 'No article',
      title_article_add: 'Add Article',
      name: 'Name',
      name_placeholder: 'Name',
      featured_image: 'Featured Image',
      or_use_link: 'Or Use Image Link',
      author: 'By',
      doctor: 'Doctor',
      clinic: 'Clinic',
      status: 'Status',
      unpublished: 'unpublished',
      published: 'published',
      title_require: 'The title field is required.',
      content_require: 'The content field is required.',
      select_featured_image: 'Select featured image',
      create_success: 'Create Article Successful',
      update_success: 'Update Article Successful'
    },
    patient: {
      title: 'Patient',
      search_by: 'Search name, id card, phone',
      patient_list: 'Patients',
      no_patient: 'No patient',
      required_info: 'Information',
      firstname: 'Firstname',
      lastname: 'Lastname',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      phone_no: 'Phone',
      contact: 'Contact',
      email: 'Email',
      address: 'Address',
      personal_info: 'Personal Information',
      id_card: 'ID Card',
      birthdate: 'Birthdate',
      allergy: 'Allergy',
      diseases: 'Diseases',
      relative_info: 'Relative',
      relative_name: 'Relative Name',
      relative_relation: 'Relative Relation',
      relative_phone: 'Relation Phone',
      create_success: 'Create new patient successful!',
      firstname_require: 'The firstname field is required.',
      lastname_require: 'The lastname field is required.',
      phone_require: 'The phone field is required.',
      birthday_require: 'The birthday field is required.',
      prefix: 'Prefix',
      prefix_placeholder: 'Prefix',
      prefix_mrs: 'Mrs',
      prefix_mr: 'Mr',
      prefix_ms: 'Ms',
      prefix_master: 'Master',
      prefix_miss: 'Miss',
      hn: 'HN'
    },
    report: {
      title: 'Statistics',
      view_and_appointment: 'Visitor and Appointment',
      visitor_detail: 'Visitor Detail',
      male: 'Male',
      female: 'Female',
      article: 'Article',
      popular_article: 'Popular Article',
      article_visitor: 'visitor',
      article_appointment: 'appointment',
      no_article: 'No article',
      popular_doctor: 'Popular Doctor',
      doctor_rank: 'Rank',
      doctor_name: 'Name',
      doctor_appointment_count: 'Appointment',
      today: 'Today',
      week: 'This week',
      month: 'This month',
      year: 'This year',
      status_summary: 'Status Summary',
      status_pending: 'Pending',
      status_checkin: 'Check-in',
      status_cancel: 'Cancel',
      status_scheduled: 'Scheduled'
    },
    dashboard: {
      title: 'Dashboard',
      notification: 'Notifications',
      appointment_m: 'Appointments in 30 days',
      appointment: 'Appointment',
      view_all_appointment: 'View all apppointments on this day',
      visitor_m: 'Visitors in 30 days',
      visitor: 'Visitor',
      view_all_visitor: 'View all statistics on this day',
      notification_appointment_first: 'Pending <strong>',
      notification_appointment_last: ' Appointments</strong>',
      notification_action: 'View appointments'
    },
    doctor_header: {
      title_new: 'Create Profile',
      title_edit: 'Edit Profile',
      personal_info: 'Personal Information',
      experience: 'Experience',
      schedules: 'Schedules',
      education: 'Education',
      other_info: 'Other Information'
    },
    doctor_general: {
      name_th: 'Name (Thai)',
      prefix: 'Prefix',
      prefix_placeholder_th: 'นพ., พญ.',
      firstname: 'Firstname',
      lastname: 'Lastname',
      name_en: 'Name (English)',
      prefix_placeholder_en: 'Dr..',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      image: 'Photo',
      select_image: 'Select your photo',
      albums: 'Albums'
    },
    doctor_experience: {
      specialty: 'Specialty',
      specialty_placeholder: 'Select specialty',
      subspecialty: 'Subspecialty',
      subspecialty_placeholder: 'Select subspecialty',
      medical_procedure_th: 'Medical Procedure (Thai)',
      medical_procedure_en: 'Medical Procedure (English)',
      medical_procedure_placeholder: 'Medical procedure',
      place: 'Work Addresses',
      clinic_place: 'Clinic',
      clinic_place_placeholder: 'Select or typing clinic name',
      institute_place: 'Institute',
      institute_place_placeholder: 'Select institute'
    },
    doctor_education: {
      education_info: 'Educations',
      education_info_th: 'Education (Thai)',
      education_info_en: 'Education (English)',
      certifications: 'Certifications',
      certifications_th: 'Certification (Thai)',
      certifications_en: 'Certification (English)',
      license_number: 'License Number',
      professional_memberships: 'Professional Memberships',
      professional_memberships_th: 'Professional Membership (Thai)',
      professional_memberships_en: 'Professional Membership (English)'
    },
    doctor_schedules: {
      schedule: 'Schedules',
      online_appointment_on: 'Online Appointment',
      select_time_slot_for: 'Select Time of '
    },
    doctor_info: {
      language: 'Language',
      language_placeholder: 'Allows to select more than one language',
      video_links: 'Related Video',
      youtube_link: 'Youtube Link',
      addition_info: 'Additional Information',
      addition_info_th: 'Information (Thai)',
      addition_info_en: 'Information (English)',
      save_success: 'Update Profile Successful',
      create_success: 'Create Profile Successful'
    },
    alert_bar: {
      title: 'Please complete your profile',
      message: 'Please complete the form to activate your account or contact administrator for additional information.',
      contact: 'Tel: 092-462-6633 (Fah)'
    },
    alert_bar_payment: {
      message: 'Your profile is not list in the search result. To active profile go to',
      contact: 'Tel: 092-462-6633 (Fah)'
    },
    alert_bar_sms_warning: {
      title: 'Your Sms credit is running out',
      message: 'In your account, there are ',
      contact: 'To top up the credit, please contact 092-462-6633 (Fah)'
    },
    drop_zone: {
      place_holder: 'Drag your file(s) here to begin<br> or click to browse'
    },
    appointment: {
      title_edit: 'Appointment',
      title_add: 'New Appointment',
      status_scheduled: 'Scheduled',
      status_cancel: 'Cancel',
      status_checkin: 'Check-In',
      status_patient_confirm: 'Patient Confirm',
      status_patient_confirm_3hr: 'Patient Confirm (3 Hours)',
      label_date_time_appointment: 'Appointment Date',
      doctor: 'Doctor',
      doctor_placeholder: 'Select Doctor',
      search_patient_placeholder: 'Search patient name, email, phone',
      prefix: 'Prefix',
      prefix_placeholder: 'Prefix',
      firstname: 'Firstname',
      firstname_placeholder: 'Firstname',
      lastname: 'Lastname',
      lastname_placeholder: 'Lastname',
      phone: 'Phone',
      email: 'Email',
      email_placeholder: 'Email',
      seen_doctor: 'Have you ever visited a doctor?',
      have: 'Yes, I have.',
      have_not: 'No, I haven\'t',
      medical_record: 'Have you had a medical record?',
      have_yes: 'Yes, I have.',
      have_no: 'No, I haven\'t',
      booking_for: 'For',
      myself: 'Myself',
      another: 'Another',
      id_card: 'ID Card / Passport',
      birthdate: 'Birthday',
      service: 'Service',
      service_placeholder: 'Select service',
      duration: 'Duration',
      duration_placeholder: 'Select duration',
      duration_unit: 'Minutes',
      addition: 'Chief Complain',
      addition_placeholder: 'Chief Complain',
      remark: 'Email/SMS remark',
      remark_placeholder: 'For patient notification',
      admin_remark: 'Admin remark',
      admin_remark_placeholder: 'Admin remark',
      are_you_wath_to_cancel: 'Do you want to cancel this appointment?',
      cancel_appointment_success: 'Cancel Appointment Successful!',
      firstname_require: 'The firstname field is required.',
      lastname_require: 'The lastname field is required.',
      phone_require: 'The phone field is required.',
      email_require: 'The email field is required.',
      doctor_require: 'The doctor field is required.',
      prefix_mrs: 'Mrs',
      prefix_mr: 'Mr',
      prefix_ms: 'Ms',
      prefix_master: 'Master',
      prefix_miss: 'Miss',
      pending_view: 'Pending',
      appointment_view: 'Appointment',
      search_appointment: 'Search name, email, phone',
      no_appointment: 'No appointment',
      add_appointment: 'New Appointment',
      appointment_date: 'Appointment Date',
      title_appointmemt: 'Appointment',
      daily_view: 'Daily',
      weekly_view: 'Weekly',
      monthly_view: 'Monthly',
      list_view: 'List',
      filter_date_all: 'All',
      filter_date_range: 'Range',
      filter_date_range_placeholder: 'Range',
      filter_specialty: 'Specialty',
      filter_doctor: 'Doctor',
      filter_clinic: 'Clinic',
      filter_status: 'Status',
      filter_service: 'Service',
      filter_hn: 'HN',
      filter_search: 'Patient name, Phone, HN or ID card',
      order: 'No',
      date: 'Date',
      patient: 'Patient',
      doctor_name: 'Doctor',
      service_name: 'Service',
      patient_status: 'Scheduled',
      appointment_status: 'Status',
      no_appointment_with_filter: 'No appointment',
      new_patient: 'New Patient',
      old_patient: 'Old Patient',
      view_more: 'More details',
      cancel_appointment: 'Cancel Appointment',
      doctor_list: 'Doctors',
      confirm_status: 'Confirmed',
      not_confirm_status: 'Not confirm',
      latest_reminded_time: 'Latest Reminded Time',
      locale: 'Language',
      locale_placeholder: 'Language',
      hn: 'HN',
      export_appointments: 'Export'
    },
    feedback: {
      title: 'Feedback',
      appointment_no: 'No.',
      appointment_date: 'Date',
      patient_name: 'Patient',
      doctor_name: 'Doctor',
      score: 'Score',
      comment: 'Comment',
      no_comment: 'No feedback'
    },
    remarks: {
      title_remark_editor: 'Edit Remark Template',
      name: 'Name',
      remark: 'Remark'
    }
  },
  action_message: {
    cancel: 'Cancel',
    ok: 'OK',
    save: 'Save',
    back: 'Back',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    list: 'List',
    view: 'View',
    are_you_sure: 'Are you sure?',
    close: 'Close',
    view_more: 'More',
    save_success: 'Save Successful',
    save_not_success: 'Save Failure',
    download_qr_code: 'Download QR Code'
  }
}



// WEBPACK FOOTER //
// ./src/lang/localization-en.js